import React, { ComponentType } from "react";

const branch = <P extends object>(test: boolean, ComponentOnPass: ComponentType<P>, ComponentOnFail?: ComponentType<P>) => (props: P): JSX.Element => (
    test ? (<ComponentOnPass {...props} />) : ComponentOnFail ? (<ComponentOnFail {...props} />) : <React.Fragment></React.Fragment>
);

export default branch;
